import React from 'react';
import { Table, Tag } from 'antd';

const emptyCell = <span className="empty-cell" aria-label="空值">--</span>;
const textOrEmpty = value => value === null || value === undefined || value === '' ? emptyCell : value;

const platformFor = store => {
  if (store.onMeituan && store.onEleme) return <Tag color="red">美团+饿了么</Tag>;
  if (store.onMeituan) return <Tag color="gold">美团</Tag>;
  if (store.onEleme) return <Tag color="blue">饿了么</Tag>;
  return <Tag>线下</Tag>;
};

const StoreCompassTable = ({ stores, loading, selectedKeys, onSelectionChange }) => {
  const columns = [
    { title: '门店需求指数', dataIndex: 'demandScore', width: 110, sorter: (a, b) => (a.demandScore ?? -1) - (b.demandScore ?? -1),
      defaultSortOrder: 'descend', render: value => value === null || value === undefined
        ? emptyCell
        : <span className={`demand-score score-${value >= 150 ? 's' : value >= 100 ? 'a' : value >= 60 ? 'b' : 'c'}`}>{value}</span> },
    { title: '门店名称', dataIndex: 'name', width: 180, ellipsis: true, render: textOrEmpty },
    { title: '门店类型', dataIndex: 'childType', width: 130, ellipsis: true, render: textOrEmpty },
    { title: '经营品类', dataIndex: 'parentType', width: 130, ellipsis: true, render: textOrEmpty },
    { title: '连锁/状态', width: 110, render: () => emptyCell },
    { title: 'O2O来源', key: 'platform', width: 125, render: (_, record) => platformFor(record) },
    { title: '年龄分层', width: 120, render: (_, record) => record.ageTags?.length
      ? <div className="data-tags vertical">{record.ageTags.map(item => <Tag color="orange" key={item.label} title={`${item.value.toLocaleString()}人`}>{item.label}</Tag>)}</div>
      : emptyCell },
    { title: '收入分布', width: 105, render: (_, record) => record.incomeTags?.length
      ? <div className="data-tags vertical">{record.incomeTags.map(item => <Tag color="green" key={item.label} title={`${item.value.toLocaleString()}人`}>{item.label}</Tag>)}</div>
      : emptyCell },
    { title: '地标标签', width: 110, render: (_, record) => record.landmarkTags?.length
      ? <div className="data-tags vertical">{record.landmarkTags.map(item => (
        <Tag color="blue" key={item.label} title={`POI特征指数：${item.value.toFixed(2)}；相关点位：${item.count}个`}>
          {item.label}
        </Tag>
      ))}</div>
      : emptyCell },
    { title: '场景标签', width: 110, render: () => emptyCell },
    { title: '所属街道', dataIndex: 'street', width: 130, ellipsis: true, render: textOrEmpty },
    { title: '街道需求分', dataIndex: 'streetDemandScore', width: 110,
      render: (value, record) => value === null || value === undefined
        ? emptyCell
        : <span title={record.demandAreaName ? `匹配区域：${record.demandAreaName}` : '按当前可用区域数据计算'}>{value}</span> },
    { title: '地址', dataIndex: 'address', width: 420,
      render: value => value ? <span className="full-address">{value}</span> : emptyCell },
  ];

  return <Table className="compass-table" rowKey="_key" size="small" loading={loading}
    dataSource={stores} columns={columns}
    rowSelection={{ selectedRowKeys: selectedKeys, onChange: onSelectionChange }}
    onRow={record => ({ onClick: event => {
      if (event.target.closest('.ant-checkbox-wrapper')) return;
      const selected = selectedKeys.includes(record._key);
      const keys = selected ? selectedKeys.filter(key => key !== record._key) : [...selectedKeys, record._key];
      onSelectionChange(keys, stores.filter(item => keys.includes(item._key)));
    } })}
    rowClassName={record => selectedKeys.includes(record._key) ? 'compass-row-selected' : ''}
    pagination={false} scroll={{ x: 1900, y: 310 }}
    locale={{ emptyText: '请开启供给数据并选择地区或门店类型' }} />;
};

export default StoreCompassTable;
